import { render, staticRenderFns } from "./AssetDefault.vue?vue&type=template&id=996b76f8"
import script from "./AssetDefault.vue?vue&type=script&lang=js"
export * from "./AssetDefault.vue?vue&type=script&lang=js"
import style0 from "./AssetDefault.vue?vue&type=style&index=0&id=996b76f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports